import { db } from '@/main';
import router from '@/router'

export const namespaced = true

export const state = () => ({
	user: {
		id: null,
		user_uid: '',
		name: '',
		email: '',
		phone: '',
		address: '',
		role: 'guest',
		active: true,
	},

})

export const mutations = {
	SET_USER: (state, payload) => {
		state.user = payload
	}
}

export const actions = {

	getUser({ commit,state }, uid) {

		return db.collection('customers').where('user_uid', '==', uid).limit(1).get()
			.then(snap => {
				snap.forEach(doc => {
					commit('SET_USER', doc.data())
				});
			})

	},

}

export const getters = {
	role: state => {
		return state.user.role
	},
	isActive: state => {
		return state.user.active
	},
	currentUser: state => {
		return state.user
	}
}